import styled, { css } from 'styled-components';
import background from '@/media/onboarding/sitebuilder-v2/bg-gradient.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    width: 100%;
    position: relative;
    padding: 0;
  `}
`;

export const WaveTop = styled.div`
  ${({ theme }) => css`
    background: url(${background}) no-repeat center top;
    background-size: 100% 300px;
    height: 300px;
    overflow: hidden;
    width: 100%;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background-size: 100% 180px;
      height: 180px;
    }
  `};
`;

export const CirclesImage = styled.img`
  ${({ theme }) => css`
    height: 320px;
    right: 5vw;
    position: absolute;
    top: -215px;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      top: -60px;
      right: -60px;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 145px;
      right: -80px;
    }
  `}
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    height: 400px;
    top: -255px;
    position: absolute;
    left: -3vw;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      left: -40px;
      top: 40px;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 144px;
    }
  `};
`;

export const InnerContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    position: relative;
    z-index: 2;
    top: -50px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0 auto;
      max-width: 100%;
      flex-direction: column;
      top: -30px;
    } 
  `}
`;

export const SiteCreatedBlock = styled.div`
  ${({ theme, showAgentBlock }) => css`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    align-self: stretch;
    padding: ${showAgentBlock ? '36px 0 0 0' : '0'};
    width: 100%;
    max-width: ${showAgentBlock ? '645px' : '100%'};
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: auto;
      max-width: 100%;
      padding: 0;
    }     
  `}    
`;

export const SiteCreatedTitle = styled.p`
  ${({ theme, showAgentBlock }) => css`
    background: ${theme.v2.colors.gradient.tertiary};
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    font-size: ${showAgentBlock ? theme.v2.font.sizes.md : theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0 0 24px 0;
    text-align: center;
    width: 100%;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const SiteCreatedButtonContainer = styled.div`
  ${({ theme }) => css`
    margin: 0 0 24px 0;
    width: 100%;  
    display: flex;
    justify-content: center;  
    align-items: center;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `}
`;

export const SliderContainer = styled.div`

`;

export const SliderImage = styled.div`

`;

export const AgentBlock = styled.div`
  ${({ theme, showAgentBlock }) => css`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    max-width: ${showAgentBlock ? '645px' : '100%'};
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }   
  `}
`;

export const DivisionBorder = styled.div`
  ${({ theme }) => css`
    min-width: 2px;
    height: 490px;
    background: 
      repeating-linear-gradient(
        to bottom,
        #2FEAA8 0px,
        #20e3b2 5px,
        transparent 5px,
        transparent 10px
      );
    background-size: 2px 100%;
    background-repeat: repeat-y;
    background-position: left center;
    background-clip: content-box;
    margin: 0 75px;
    align-self: stretch;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: block;
      margin: 24px 0;
      width: 100%;
      height: 2px;
      min-width: 100%;
      background: 
        repeating-linear-gradient(
          to right,
          #2FEAA8 0px,
          #20e3b2 5px,
          transparent 5px,
          transparent 10px
        );
      background-size: 100% 2px;
      background-repeat: repeat-x;
      background-position: center top;
    }
  `}
`;

export const AgentBlockTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text}; 
    color: ${theme.v2.colors.brand.primaryBlue};
    margin: 0 0 8px 0;
    text-align: center;
    padding: 0;
    width: 100%;
    max-width: 500px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
      max-width: 100%;
    }
  `};
`;

export const AgentBlockSubTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.title}; 
    color: ${theme.v2.colors.neutral.lowMedium};
    margin: 0 0 24px 0;
    text-align: center;
    padding: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const AgentBlockBenefitsContainer = styled.div`
  ${({ theme }) => css`
    margin: 0 0 24px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0 0 32px 0;   
      width: 100%;
      position: relative;
      right: -24px;
    }
  `};
`;

export const AgentBlockBenefitsContent = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.md}) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 20px;
      width: 100%;
      max-width: 408px;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 12px;
        justify-content: flex-start;
        overflow-x: auto;
        scrollbar-width: none;
        padding-right: 24px;
        margin-left: -24px;        
    }
  `};
`;

export const AgentBlockBenefitsBox = styled.div`
  ${({ theme }) => css`
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    align-self: stretch;
    position: relative;

    background: #FFFFFF;
    background-clip: padding-box;
    border: 1px solid transparent;
    border-radius: 16px;  

    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      margin: -1px;
      border-radius: inherit;
      background: ${theme.v2.colors.gradient.primary};
    }    

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px 12px;
      min-width: 36%;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-width: 55%;
    }   

    @media (max-width: ${theme.v2.breakpoints.xs}) {
      min-width: 55%;
    }        
  `};
`;

export const Svg = styled.svg`
  ${({ width, height }) => css`
    width: ${width}px !important;
    height: ${height}px !important;
  `};   
`;


export const AgentBlockBenefitsDescription = styled.div`
  ${({ theme }) => css`
    margin: 16px 0 0 0;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.title}; 
    color: ${theme.v2.colors.neutral.lowPure};
    text-align: center;
    padding: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }  
  `};    
`;

export const AgentBlockButtonLink = styled.div`
  ${({ theme }) => css`
    border-radius: 30px;
    cursor: pointer;
    display: inline-flex;
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 12px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    transition: 0.2s ease-in-out;
    font-size: ${theme.v2.font.sizes.xs};
    align-items: center;
    color: ${theme.v2.colors.white.primary};
    background: linear-gradient(25deg, #0072ff 0%, #00c6ff 50%, #00c6ff 100%);
    position: relative;
    user-select: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }  

    &:hover{
      background: linear-gradient(25deg, #00c6ff 0%, #00c6ff 50%, #0072ff 100%);
    }

    a{
      padding: 13px 16px;
      text-decoration: none;
      color: inherit;

      &:hover {
        text-decoration: none; 
        color: inherit;
      }
    }

    svg{
      position: absolute;
      top: 50%;
      right: 24px;
      transform: translateY(-50%);
    }
  `};       
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
`;

export const SkeletonContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 0 75px;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const SkeletonBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 645px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    max-width: 100%;
  }
`;

export const SuccessAnimation = styled.img`
  width: 100%;
  height: auto;
  max-width: 900px;
  max-height: 547px;  
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  object-fit: cover;
  margin: 0 auto;
  animation: fadeOut 6s forwards;

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    83.33% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
